import VehicleSelector from './vehicle-selector';

export default class SearchComponent {
  protected readonly vehicleSelector?: VehicleSelector;

  constructor(protected container: HTMLElement) {
    const vehicleSelectorContainer = container.querySelector('.js-vehicleSelector');
    if (vehicleSelectorContainer instanceof HTMLElement) {
      this.vehicleSelector = new VehicleSelector(vehicleSelectorContainer);
    }
  }
}
